import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-[100dvh] flex flex-col items-center justify-center bg-black text-white px-6">
          <h1 className="text-2xl font-bold mb-4">Something went wrong</h1>
          <p className="text-zinc-400 text-sm mb-6 text-center">An unexpected error occurred. Please refresh the page to continue.</p>
          <button onClick={() => window.location.reload()} className="px-6 py-2 rounded-full bg-pink-500 hover:bg-pink-400 text-sm font-bold">Refresh page</button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
